import { api } from "../api";

export const fetchStoppedCampaignBatches = async ({ customerId }) => {
  const result = await api.view(
    `($customerId: String) {
      sendings {
        sendingBatchId
        bucket: count(1)
        [where customerId == $customerId && status == "stopped" && sendingBatchId != null group by sendingBatchId]
      }
    }`,
    { customerId },
  );

  const batchIds = result?.sendings?.map((s) => s.sendingBatchId) || [];

  const enrichedBatches = await Promise.all(
    batchIds.map(async (batchId) => {
      let sendings = [];
      let tmp = await api.sending.findMany({
        first: 250,
        filter: {
          customerId: { equals: customerId },
          sendingBatchId: { equals: batchId },
          status: { equals: "stopped" },
        },
        select: {
          id: true,
          sendingDate: true,
          contactList: true,
          campaign: { name: true, id: true },
          segment: { name: true },
          segmentFilters: true,
          contactListSegment: {
            externalId: true,
            type: true,
          },
        },
        sort: { sendingDate: "Ascending" },
      });

      sendings = sendings.concat(tmp);

      while (tmp.hasNextPage) {
        tmp = await tmp.nextPage();
        sendings = sendings.concat(tmp);
      }

      if (sendings.length === 0) return null;

      return {
        sendingBatchId: batchId,
        campaignName: sendings[0].campaign?.name || "-",
        campaignId: sendings[0].campaign?.id,
        segmentName: sendings[0].segment?.name || "-",
        segmentFilters: sendings[0].segmentFilters,
        contactListSegment: sendings[0].contactListSegment,
        originalSendingDate: new Date(sendings[0].sendingDate),
        totalContacts: sendings.reduce(
          (sum, s) => sum + (s.contactList?.length || 0),
          0,
        ),
      };
    }),
  );

  return enrichedBatches
    .filter((b) => b !== null)
    .sort((a, b) => a.originalSendingDate - b.originalSendingDate);
};
